const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-marketing-scripts'] = {
        c: () => require('partner/modules/moe-marketing-scripts/moe-marketing-scripts.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-marketing-scripts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-marketing-scripts'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-marketing-scripts|moe-marketing-scripts'] = {
                c: () => require('partner/modules/moe-marketing-scripts/moe-marketing-scripts.view.tsx'),
                cn: '__local__-__local__-moe-marketing-scripts'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };